// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"125":"23dab1cb","314":"94bd0eba"}[chunkId] + ".css";
};